module.exports = __webpack_public_path__ + "static/media/database.0d852e57.svg";